import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { ModalSolicitacaoComentario, SolicitacaoComentario } from '@/types/_'

@Module({ namespaced: true, name: 'SolicitacaoComentariosStore' })
export default class SolicitacaoComentariosStore extends VuexModule {
  public solicitacaoId: string = ''
  public comentarios: SolicitacaoComentario[] = []
  public modal: ModalSolicitacaoComentario = { comentario: false }

  @Action({ commit: 'setComentario' })
  async send(comentario: SolicitacaoComentario) {
    const request = await Apis.Agendamento.SolicitacaoComentarioApi.enviarComentario(this.solicitacaoId, comentario)
    if (request.success) {
      return comentario
    }
    return comentario
  }

  @Action
  async enviarLembrete(params: any) {
    const request = await Apis.Agendamento.SolicitacaoComentarioApi.defineLembrete(params)
    return request
  }

  @Action({ commit: 'setComentarios' })
  async getComentariosBySolicitacaoId(solicitacaoId: string, tipo: string = 'comentario') {
    try {
      const request = await Apis.Agendamento.SolicitacaoComentarioApi.getComentariosBySolicitacaoId(solicitacaoId, tipo)
      if (request.success) this.context.commit('setSolicitacaoId', solicitacaoId)
      return request.success ? request.data : []
    } catch (error) {
      return []
    }
  }

  @Mutation
  setShowModalComentario(value: boolean) {
    this.modal.comentario = value
  }

  @Mutation
  setComentario(comentario: SolicitacaoComentario) {
    if (comentario) {
      this.comentarios.push(comentario)
    }
  }

  @Mutation
  setComentarios(comentarios: SolicitacaoComentario[]) {
    this.comentarios = comentarios
  }

  @Mutation
  clearComentarios() {
    this.comentarios = []
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.solicitacaoId = solicitacaoId
  }

  @Mutation
  clearSolicitacaoId() {
    this.solicitacaoId = ''
  }

  @Action
  async concluirLembrete() {
    try {
      const request = await Apis.Agendamento.SolicitacaoComentarioApi.concluirLembrete(this.solicitacaoId)
      return request
    } catch (error) {
      return { success: false, message: 'Não foi possível concluir o lembrete' }
    }
  }
}
